import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { navigationMenu: navMenu } = semanticThemeTokens;

export const navMenuItemSelectedLabel = style({
  display: "inline-flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  whiteSpace: "nowrap",
  // Let the label shrink inside the trigger and clip its own overflow, so a
  // long "Module / Route" pair ellipsises instead of forcing the tab wider
  // than its track.
  minWidth: 0,
  overflow: "hidden"
});

/**
 * A text segment of the nav label (the module name and the selected-route
 * name). Truncates with an ellipsis when the tab is too narrow to show it in
 * full; the diagonal-line separator between them keeps its intrinsic size.
 */
export const navMenuItemLabelText = style({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});

export const navMenuItemSelected = style({
  color: navMenu.selected.color
});
